module.exports = __webpack_public_path__ + "static/img/code.25c0567.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/code.jpg
// module id = 6m72
// module chunks = 0